import { render, staticRenderFns } from "./CarrierClassificationCreateOrUpdate.vue?vue&type=template&id=39dd3d8e&"
import script from "./CarrierClassificationCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./CarrierClassificationCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports